import { createContext, useContext } from 'react';
export const BreakpointsContext = /*#__PURE__*/createContext(null);
export const useBreakpointsContext = () => {
  const contextValue = useContext(BreakpointsContext);
  if (contextValue === null) {
    throw new Error('Component must be inside BreakpointsProvider component');
  }
  return contextValue;
};